// src/components/SEO.jsx
import React from 'react';
import { Helmet } from 'react-helmet-async';

// Prefer env when present, fall back to production domain; remove trailing slash
const rawSiteUrl =
  (process.env.REACT_APP_SITE_URL && String(process.env.REACT_APP_SITE_URL)) ||
  'https://talkvee.com';
const SITE_URL = rawSiteUrl.replace(/\/+$/, '');

export default function SEO({
  title = 'Talkvee - Best Omegle Alternative for Random Video Chat',
  description = 'Talkvee is a free random video chat and Omegle alternative. Meet new people instantly via video or text.',
  pathname = '/',
  robots = 'index, follow',
  image = '/og-image.png',
  imageAlt = 'Talkvee preview image',
  type = 'website',
  locale = 'en_US',
  publishedTime,
  modifiedTime,
  meta = [],
  // ✨ NEW: Accept structured data directly
  jsonLd, 
}) {
  const cleanPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  const url = `${SITE_URL}${cleanPath}`;
  const imageUrl = image.startsWith('http') ? image : `${SITE_URL}${image}`;

  const ogMeta = [
    { property: 'og:type', content: type },
    { property: 'og:title', content: title },
    { property: 'og:description', content: description },
    { property: 'og:url', content: url },
    { property: 'og:image', content: imageUrl },
    { property: 'og:site_name', content: 'Talkvee' },
    { property: 'og:locale', content: locale },
  ];

  if (publishedTime) ogMeta.push({ property: 'article:published_time', content: publishedTime });
  if (modifiedTime) ogMeta.push({ property: 'article:modified_time', content: modifiedTime });

  const twitterMeta = [
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: description },
    { name: 'twitter:image', content: imageUrl },
  ];

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Robots directives */}
      <meta name="robots" content={robots} />
      <meta name="googlebot" content={robots} />

      {/* Canonical */}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      {ogMeta.map((m, i) => (
        <meta key={`og-${i}`} {...m} />
      ))}
      <meta property="og:image:alt" content={imageAlt} />

      {/* Twitter */}
      {twitterMeta.map((m, i) => (
        <meta key={`tw-${i}`} {...m} />
      ))}

      {/* Any extra meta passed in */}
      {meta.map((m, i) => (
        <meta key={`extra-${i}`} {...m} />
      ))}

      {/* ✨ NEW: Render JSON-LD if provided */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}